import { Page } from "@/models/page-models/Page";

export const Goods: Page = {
  "path": "goods",
  "name": "Goods",
  "props": {
    "data": {
      "title": "Goods",
      "printable": "FALSE",
      "url": "goods",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.supplier",
                  "label": "Select Supplier",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultPageNo",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultPageNo",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.goodSearch",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultPageNo"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getRmsBySupplier",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/goods/supplier/{{formData.supplier}}/raw-material",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.goods",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.goodSearch"
                      },
                      "name": "getRmsBySupplier"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "validationKey": "supplier"
                },
                {
                  "type": "button",
                  "label": "Add New RM",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToGoodsEditor",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/goodsEditor"
                      }
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData.rmTable",
                  "label": "RM",
                  "disabled": "FALSE",
                  "items": "fetchedData.goods.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "RM#",
                      "type": "url",
                      "url": "/goodsEditor/{{__item._id}}"
                    },
                    {
                      "value": "__item.type",
                      "text": "RM Type"
                    },
                    {
                      "value": "__item.details",
                      "text": "RM Details",
                      "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                    },
                    {
                      "value": "__item.density",
                      "text": "Density",
                      "type": "formula",
                      "formula": "{{__item.density}} {{__item.densityUnit}}"
                    },
                    {
                      "value": "__item.location",
                      "text": "Quantity",
                      "formula": "fn(HELPER_FN,goodsLocationsOverview,{{__item.location}})",
                      "width": 165
                    }
                  ],
                  "tableType": "static",
                  "onRowClick": {
                    "type": "url",
                    "value": "/goodsEditor/__item._id"
                  },
                  "pagination": {
                    "pageVariable": "fetchedData.goodSearch.page",
                    "serverItemsLengthVariable": "fetchedData.goods.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getRmsBySupplier",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v2/goods/supplier/{{formData.supplier}}/raw-material",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.goods",
                          "arg3Key": "postData",
                          "arg3Value": "fetchedData.goodSearch"
                        },
                        "name": "getRmsBySupplier"
                      }
                    ]
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMySuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/my",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getMySuppliers",
        "executeIf": "fn(MATCH_ROLE,Commercial | Purchaser)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": true
}